import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { BankAccountSettingsFormValues } from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';
import { Col, Form, FormInstance, Row, Select } from 'antd';

interface Props {
  form: FormInstance<BankAccountSettingsFormValues>;
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipDiscountForm({
  form,
  bankAccount,
}: Props) {
  const titleDiscountCodeOptions = [
    { value: '0', label: 'Sem instrução de desconto.' },
    { value: '1', label: 'Valor Fixo Até a Data Informada.' },
    { value: '2', label: 'Percentual Até a Data Informada.' },
    { value: '3', label: 'Valor por Antecipação Dia Corrido.' },
    { value: '4', label: 'Valor por Antecipação Dia Útil.' },
    { value: '5', label: 'Percentual Sobre o Valor Nominal Dia Corrido.' },
    { value: '6', label: 'Percentual Sobre o Valor Nominal Dia Útil.' },
    { value: '7', label: 'Cancelamento de Desconto.' },
  ];

  const bankMapFields = bankAccount ? bankConfig[bankAccount?.bank.code] : null;

  const titleDiscountCodeFilters = !!bankMapFields?.fields.titleDiscountCode
    ?.options?.length
    ? titleDiscountCodeOptions.filter((item) =>
        bankMapFields?.fields.titleDiscountCode?.options?.includes(item.value),
      )
    : titleDiscountCodeOptions;

  return (
    <Form form={form} name="bankAccountConfigBullet">
      <Row gutter={[12, 12]}>
        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Código desconto"
            name={['discount', 'titleDiscountCode']}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={titleDiscountCodeFilters}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Dias Desc. antes vencimento"
            name={['discount', 'titleDiscountDays']}
          >
            <InputDecimal fractions={0} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Valor Desconto Taxa"
            name={['discount', 'titleDiscountRateValue']}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Valor Desconto"
            name={['discount', 'titleDiscountValue']}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Código desconto 2"
            name={['discount', 'titleDiscountCode2']}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={titleDiscountCodeFilters}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Dias Desc. antes vencimento 2"
            name={['discount', 'titleDiscountDays2']}
          >
            <InputDecimal fractions={0} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Valor Desconto Taxa 2"
            name={['discount', 'titleDiscountRateValue2']}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        {bankMapFields?.fields.titleDiscountCode3?.visible && (
          <Col span={24} md={12} lg={6} xxl={4}>
            <FloatingFormItem
              label="Código desconto 3"
              name={['discount', 'titleDiscountCode3']}
            >
              <Select
                allowClear
                style={{ width: '100%' }}
                options={titleDiscountCodeFilters}
              />
            </FloatingFormItem>
          </Col>
        )}

        {bankMapFields?.fields.titleDiscountDate3?.visible && (
          <Col span={24} md={12} lg={6} xxl={4}>
            <FloatingFormItem
              label="Dias Desc. antes vencimento 3"
              name={['discount', 'titleDiscountDays3']}
            >
              <InputDecimal fractions={0} />
            </FloatingFormItem>
          </Col>
        )}

        {bankMapFields?.fields.titleDiscountRateValue3?.visible && (
          <Col span={24} md={12} lg={6} xxl={4}>
            <FloatingFormItem
              label="Código desconto 3"
              name={['discount', 'titleDiscountRateValue3']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        )}
      </Row>
    </Form>
  );
}
